// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"AllCourses_wrapper__2rsan","list":"AllCourses_list__2W2md","container":"AllCourses_container__1iHdU"};